export const container = `
  text-sm text-base-black text-nowrap font-bold truncate
  w-full m-0 justify-self-start overflow-hidden
`;
